import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
export var signS3Express = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(s3ExpressIdentity, signingOptions, request, sigV4MultiRegionSigner) {
    var signedRequest;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return sigV4MultiRegionSigner.signWithCredentials(request, s3ExpressIdentity, {});
          case 2:
            signedRequest = _context.sent;
            if (!(signedRequest.headers["X-Amz-Security-Token"] || signedRequest.headers["x-amz-security-token"])) {
              _context.next = 5;
              break;
            }
            throw new Error("X-Amz-Security-Token must not be set for s3-express requests.");
          case 5:
            return _context.abrupt("return", signedRequest);
          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function signS3Express(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();